import { Subject } from 'rxjs';
const RESERVATION_DATA_KEY = "reservationData";
const BOOKING_DATA_KEY = "bookingData";
const BOOKING_STEPS_KEY = "bookingStep";
const PURCHASE_DATA_KEY = "purchaseData";
const SIGNARURE_KEY = "purchaseSignature";
export default class StorageService {

  static onSaveData = new Subject();

  static saveData(data, key=BOOKING_DATA_KEY) {
    sessionStorage.setItem(key, data);
    this.onSaveData.next({ key: key, data: data })
  }

  static getData(key=BOOKING_DATA_KEY) {
    return sessionStorage.getItem(key);
  }

  static clear(key=BOOKING_DATA_KEY) {
    sessionStorage.removeItem(key);
  }
  static clearReservation(key=RESERVATION_DATA_KEY) {
    sessionStorage.removeItem(key);
  }

  static clearPurchase(key=PURCHASE_DATA_KEY) {
    sessionStorage.removeItem(key);
  }
  static clearSignature(key=SIGNARURE_KEY) {
    sessionStorage.removeItem(key);
  }

}

export {StorageService, BOOKING_DATA_KEY, BOOKING_STEPS_KEY};